export const ZIP_CODE_PATTERN = /^[a-zA-Z0-9]*$/;
export const ZIP_CODE_MAX_LENGTH = 10;
export const ZIP_CODE_MIN_LENGTH = 2;
